export interface UserMetaKey {
  /** The User ID, formatted as USER#<UserId> */
  pk: string

  /** USERMETA */
  sk: 'USERMETA'
}

export interface UserMeta extends UserMetaKey {
  /** USERMETA */
  gsi1pk: 'USERMETA'
  /** The User ID, formatted as USER#<UserId> */
  gsi1sk: string

  total_transcribe_seconds?: number
  card_registered?: boolean
}

export interface UserAttributes {
  'custom:stripe_customer_id'?: string
}

const FREE_TRIAL_SECONDS = 30 * 60

export const freeTrialRemaining = (user: UserMeta) => {
  if (user.total_transcribe_seconds === undefined) {
    return FREE_TRIAL_SECONDS
  }

  return Math.max(
    FREE_TRIAL_SECONDS - user.total_transcribe_seconds,
    0
  )
}

export const getUserId = (user: UserMeta) => user.pk.split("#")[1]
